import type { SocialAccountConnectionAuthFlow } from "./generated-content.ts";

export const INSTAGRAM_GRAPH_API_VERSION = "v25.0";

export const INSTAGRAM_LOGIN_AUTH_URL = "https://www.instagram.com/oauth/authorize";

export const INSTAGRAM_LOGIN_TOKEN_URL = "https://api.instagram.com/oauth/access_token";

export const INSTAGRAM_GRAPH_API_BASE_URL = `https://graph.instagram.com/${INSTAGRAM_GRAPH_API_VERSION}`;

export const INSTAGRAM_LONG_LIVED_TOKEN_URL = "https://graph.instagram.com/access_token";

export const INSTAGRAM_REFRESH_TOKEN_URL = "https://graph.instagram.com/refresh_access_token";

// TODO: Enable after instagram_business_manage_insights receives Meta App Review approval.
export const INSTAGRAM_INSIGHTS_ENABLED = false;

export const INSTAGRAM_META_GRAPH_API_BASE_URL = `https://graph.facebook.com/${INSTAGRAM_GRAPH_API_VERSION}`;

export const INSTAGRAM_META_DIALOG_BASE_URL = `https://www.facebook.com/${INSTAGRAM_GRAPH_API_VERSION}`;

export const getInstagramGraphApiBaseUrl = (authFlow: SocialAccountConnectionAuthFlow): string =>
  authFlow === "meta" ? INSTAGRAM_META_GRAPH_API_BASE_URL : INSTAGRAM_GRAPH_API_BASE_URL;

export type InstagramTokenResponsePayload = {
  access_token?: string;
  expires_in?: number;
};

export const parseInstagramTokenResponsePayload = (
  json: InstagramTokenResponsePayload,
): { ok: true; accessToken: string; expiresIn: number | null } | { ok: false } => {
  if (!json.access_token) {
    return { ok: false };
  }

  return {
    ok: true,
    accessToken: json.access_token,
    expiresIn:
      typeof json.expires_in === "number" && Number.isFinite(json.expires_in)
        ? json.expires_in
        : null,
  };
};
